import { Button, MessageBar, MessageBarActions, MessageBarBody, MessageBarTitle } from '@fluentui/react-components';
import { ArrowRightRegular } from '@fluentui/react-icons';

import { TChangePlan } from '../../models';
import { getPlanReadiness } from '../../utils';

type TProps = {
  plan: TChangePlan;
  onStartExecution: () => void;
  disabled?: boolean;
};

// A compact plan-readiness section, shown only when relevant (prompt Part 7).
export const PlanReadinessPanel = ({ plan, onStartExecution, disabled }: TProps) => {
  const readiness = getPlanReadiness(plan);

  if (readiness.ready) {
    return (
      <MessageBar intent="success">
        <MessageBarBody>
          <MessageBarTitle>Plan ready for execution</MessageBarTitle>
          Every required task has an owner, a due date and completion criteria.
        </MessageBarBody>
        <MessageBarActions>
          <Button
            appearance="primary"
            icon={<ArrowRightRegular />}
            iconPosition="after"
            disabled={disabled}
            onClick={onStartExecution}
          >
            Start execution
          </Button>
        </MessageBarActions>
      </MessageBar>
    );
  }

  return (
    <MessageBar intent="warning">
      <MessageBarBody>
        <MessageBarTitle>
          {readiness.issues.length} item{readiness.issues.length === 1 ? '' : 's'} before the plan is ready
        </MessageBarTitle>
        {readiness.issues.join('. ')}.
      </MessageBarBody>
    </MessageBar>
  );
};
